import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { EntityObject, TwoLevelEntityIdObject, TwoLevelEntityObject } from "../../../common/types";
import { AGENT_FILTER_INCLUSION_DEFAULTS, COMMON_AGENT_FILTER_QUERY_PARAMS } from "../../agent/api";
import {
  CreateUpdateDebtAccountMovement,
  DebtAccountMovement,
  DebtAccountMovementFilterPageRequest,
  DebtAccountMovementFilterPageResult,
  DebtAccountsReportFilterExportRequest,
  DebtAccountsReportFilterPageRequest,
  DebtAccountsReportFilterPageResult,
} from "./types";

const GET_DEBT_ACCOUNTS_REPORT = ApiRequestAdapter.create("/debt-accounts-report", HttpMethod.GET);
const GET_DEBT_ACCOUNTS_EXPORT = ApiRequestAdapter.create("/debt-accounts-report/export", HttpMethod.GET);

const FILTER_DEBT_ACCOUNT_MOVEMENTS = ApiRequestAdapter.create("/agents/{0}/debt-account/movements", HttpMethod.GET);
const CREATE_MANUAL_DEBT_ACCOUNT_MOVEMENT = ApiRequestAdapter.create(
  "/agents/{0}/debt-account/movements",
  HttpMethod.POST,
);
const UPDATE_MANUAL_DEBT_ACCOUNT_MOVEMENT = ApiRequestAdapter.create(
  "/agents/{0}/debt-account/movements/{1}",
  HttpMethod.PUT,
);
const DELETE_MANUAL_DEBT_ACCOUNT_MOVEMENT = ApiRequestAdapter.create(
  "/agents/{0}/debt-account/movements/{1}",
  HttpMethod.DELETE,
);

export const debtAccountApi = {
  getDebtAccountsReport: (
    request: DebtAccountsReportFilterPageRequest,
  ): AxiosPromise<DebtAccountsReportFilterPageResult> => {
    return apiService.get(GET_DEBT_ACCOUNTS_REPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  downloadDebtAccountsExport: (request: DebtAccountsReportFilterExportRequest): AxiosPromise<Blob> => {
    return apiService.get(GET_DEBT_ACCOUNTS_EXPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
      responseType: "blob",
    });
  },
  filterDebtAccountMovements: (
    request: EntityObject<DebtAccountMovementFilterPageRequest>,
  ): AxiosPromise<DebtAccountMovementFilterPageResult> => {
    return apiService.get(FILTER_DEBT_ACCOUNT_MOVEMENTS.getParametrizedUrl(request.id), { params: request.object });
  },
  createManualDebtAccountMovement: (
    request: EntityObject<CreateUpdateDebtAccountMovement>,
  ): AxiosPromise<DebtAccountMovement> => {
    return apiService.post(CREATE_MANUAL_DEBT_ACCOUNT_MOVEMENT.getParametrizedUrl(request.id), request.object);
  },
  updateManualDebtAccountMovement: (
    request: TwoLevelEntityObject<CreateUpdateDebtAccountMovement>,
  ): AxiosPromise<DebtAccountMovement> => {
    return apiService.put(
      UPDATE_MANUAL_DEBT_ACCOUNT_MOVEMENT.getParametrizedUrl(request.id1, request.id2),
      request.object,
    );
  },
  deleteManualDebtAccountMovement: (request: TwoLevelEntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_MANUAL_DEBT_ACCOUNT_MOVEMENT.getParametrizedUrl(request.id1, request.id2));
  },
};

export const DEFAULT_DEBT_ACCOUNTS_REPORT_QUERY_PARAMS: Required<DebtAccountsReportFilterPageRequest> = {
  ...COMMON_AGENT_FILTER_QUERY_PARAMS,
  ...AGENT_FILTER_INCLUSION_DEFAULTS.NONE_INCLUDED,
  categories: [],
  balanceAsOfDate: "",
  includeZeroBalance: false,
  includeUnprocessed: false,
};
